export default __webpack_public_path__ + "static/media/pedicure.f4fc2559.jpg";